import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
import '@/styles/index.scss'

import hljs from 'highlight.js'
// import 'highlight.js/styles/googlecode.css' //样式文件
import 'highlight.js/styles/monokai-sublime.css' //样式文件
// import 'highlight.js/styles/atom-one-dark.css' //样式文件

Vue.directive('highlight', function (el) {
  let blocks = el.querySelectorAll('pre code');
  blocks.forEach((block) => {
    hljs.highlightBlock(block)
  })
})

Vue.use(ElementUI);

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
